import React, { useEffect, useRef } from "react";

export const PageClosed = ({ children, imgSrc = null, openDateTime, closeDateTime, onOpenPage }) => {
  const intervalRef = useRef();

  useEffect(() => {
    intervalRef.current = setInterval(checkTimes, 5000);
    return () => {
      clearInterval(intervalRef.current);
    };
  });

  const checkTimes = () => {
    if ((!openDateTime || openDateTime < Date.now()) && (!closeDateTime || closeDateTime > Date.now())) {
      clearInterval(intervalRef.current);
      onOpenPage();
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        background: "#fff0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <img src={imgSrc ? imgSrc : "https://www.marcobehler.com/images/guides/undraw_security_o890-526cc2fb.svg"} style={{ maxWidth: 375, height: "auto", marginBottom: 20 }} />
      {children}
    </div>
  );
};
